
export const Combo = ({ dadosPlano }) => {
  //console.log("dados plano", dadosPlano);
  let fill = dadosPlano.plano === "Titular" ? "#45e099" : "#7e33ff";
  return (
    <div className={`bloco container-plano-${dadosPlano.plano.toLowerCase()}`}>
      <div className="wrap-beneficios-planos">
        <div className={`title-plano title-${dadosPlano.plano.toLowerCase()}`}>
          <span>{dadosPlano.plano}</span>
          <span>R$ {dadosPlano.valor}</span>
        </div>

        {/*BLOCO DE BENEFÍCIOS DOS PLANOS*/}
        {dadosPlano.beneficios.map((beneficio, index) => {
          return (
            <div
              className={`beneficio-plano beneficio-plano-${dadosPlano.plano.toLowerCase()}`}
              key={index}
            >
              <div
                className={`container-icon-beneficio-${dadosPlano.plano.toLowerCase()}`}
                dangerouslySetInnerHTML={{ __html: beneficio.svg }}
              />
              <span>{beneficio.nome}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
